// Exports
export default {
	"Participant": "Participant_9jzAx",
	"IsModerationPopupOpen": "IsModerationPopupOpen_cnwoR",
	"ParticipantStatusBlock": "ParticipantStatusBlock_7aPAO",
	"ParticipantData": "ParticipantData_KAiXK",
	"DisplayName": "DisplayName_1UD2Q",
	"Mute": "Mute_ht676",
	"disabled": "disabled_hBviv",
	"ModerationItemMicrophone": "ModerationItemMicrophone_y2A9L",
	"CanModerate": "CanModerate_lfrQ3",
	"MuteIcon": "MuteIcon_5-Hdg",
	"RecordingIcon": "RecordingIcon_Px8p6",
	"BroadcastIcon": "BroadcastIcon_Tqo17",
	"ParticipantTextData": "ParticipantTextData_oBT0+",
	"ParticipantRole": "ParticipantRole_oVthe",
	"ModerationItems": "ModerationItems_kSq7B",
	"ModerationItem": "ModerationItem_XTOKQ",
	"ModerationItemMore": "ModerationItemMore_TaGJx",
	"ModerationItemIcon": "ModerationItemIcon_YHIGw",
	"ModerationItemMoreIcon": "ModerationItemMoreIcon_FO06t",
	"ModerationPopupAnchor": "ModerationPopupAnchor_t0f1d"
};
